import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CompanyWorkflow, CreateWorkflowInput, UpdateWorkflowInput, WorkflowPort } from '../domain/workflow'

const createWorkflow = async (
	port: WorkflowPort,
	input: CreateWorkflowInput,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.createWorkflow(input)
		notify.success('workflow.created')
		return workflow
	} catch {
		notify.error('workflow.createFailed')
		return null
	}
}

const updateWorkflow = async (
	port: WorkflowPort,
	input: UpdateWorkflowInput,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.updateWorkflow(input)
		notify.success('workflow.updated')
		return workflow
	} catch {
		notify.error('workflow.updateFailed')
		return null
	}
}

const publishWorkflow = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.setWorkflowStatus(id, 'active')
		notify.success('workflow.published')
		return workflow
	} catch {
		notify.error('workflow.publishFailed')
		return null
	}
}

const archiveWorkflow = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.setWorkflowStatus(id, 'archived')
		notify.success('workflow.archived')
		return workflow
	} catch {
		notify.error('workflow.archiveFailed')
		return null
	}
}

const deleteWorkflow = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.setWorkflowStatus(id, 'deleted')
		notify.success('workflow.deleted')
		return workflow
	} catch {
		notify.error('workflow.deleteFailed')
		return null
	}
}

export { createWorkflow, updateWorkflow, publishWorkflow, archiveWorkflow, deleteWorkflow }
